module.exports = __webpack_public_path__ + "static/media/logo.27f3dfc4.svg";